<!-- eslint-disable standard/no-callback-literal -->
<template>
  <div class="wrap">
    <div class="exercises-wrap">
        <div class="exercises-index-header">
          <div class="exercises-chain" style=" align-self: start;">
            <img src="../images/ico_next_l@2x.png" @click="backLastPage" style="cursor: pointer" />
          </div>
          <div class="exercises-info">
              <div class="exercises-title">{{query.name}}</div>
            <div class="exercises-time">
              <div>发布时间：{{query.release_time}}</div>
              <div>截止时间：{{query.end_time }}</div>
              <div v-if="totalScore && totalScore !== 0">总分：{{totalScore}}</div>
            </div>
          </div>
          <div class="get-score" v-if="query.type == 'check'">
                <span>得分</span>
                <span class="num">{{ showScore }}</span>
          </div>
        </div>
        <div class="comment" v-if="query.type === 'check' && query.status == 2">
          老师评语：{{ questionComment }}
          <div class="attachment-list" v-if="commentFile && commentFile.length">
                  <div class="attachment-item" v-for="(item,index) in commentFile" :key="index" @click="handleDownloadFile(item.url)">
                    <img class="file-icon" src="../images/file.png" />
                    <div class="upload-status teacher">
                      <div class="attachment-name">{{ item.title }}</div>
                      <div class="progress" v-if="item.size">
                        <span>{{item.size}}M</span>
                      </div>
                      <div class="progress" v-else-if="item.progress">
                          <span>{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
                      </div>
                    </div>
                  </div>
                </div>
        </div>
        <div class="exercises-body" v-if="!hasFinished">
          <div class="exercises-left">
            <!-- <div class="exercise-body-top" style="border: none;">
              <div class="feedback" @click="handleOpenFeedback">
                <img src="../img/ico_fankui@2x.png" />
                <span>反馈</span>
              </div>
              <div class="collect" @click="handleCollect">
                <img src="../img/shoucang.png" v-if="!collected" />
                <img src="../img/heart-o@2x.png" v-else />
                <span>收藏</span>
              </div>
            </div> -->
            <div class="exercise-TF">
              <!-- <p class="rest-time" v-if="testTime===-60">无答题时间限制</p> -->
              <!-- <p class="rest-time" v-else>剩余答题时间 {{formateSeconds(testTime)}}</p> -->
              <!-- <h3 style="padding-top: 21px;">{{questionDetail.name}}</h3> -->
              <p>
                <span>({{curQuestionNum + 1}}/{{questionList.length }})</span>
                <span v-if="questionType === 'TF'">判断题：</span>
                <span v-else-if="questionType === 'single'">单选题：</span>
                <span v-else-if="questionType === 'multiple'">多选题：</span>
                <span v-else-if="questionType === 'brief'">简答题：</span>
                {{curQuestionData.title}}
                <span>{{`（${curQuestionData.score}分）`}}</span>
              </p>
              <div class="attachment-list" v-if="curQuestionData.file&&curQuestionData.type==4">
                  <div class="attachment-item" v-for="(item,index) in curQuestionData.file" :key="index" @click="handleDownloadFile(item.url)">
                    <img v-if="item.title.endsWith('.pdf')" class="file-icon" src="../images/pdf.png"/>
                    <img v-else-if="item.title.endsWith('.zip')||item.title.endsWith('.rar')||item.title.endsWith('.7z')" class="file-icon" src="../images/yasuo.png"/>
                    <img v-else-if="item.title.endsWith('.jpg')||item.title.endsWith('.png')||item.title.endsWith('.jpeg')||item.title.endsWith('.webp')" class="file-icon" src="../images/picture.png"/>
                    <img v-else-if="item.title.endsWith('.mp4')" class="file-icon" src="../images/video.png"/>
                    <img v-else-if="item.title.endsWith('.xls')||item.title.endsWith('.xlsx')||item.title.endsWith('.xlsm')" class="file-icon" src="../images/excel.png"/>
                    <img v-else-if="item.title.endsWith('.ppt')" class="file-icon" src="../images/ppt.png"/>
                    <img v-else class="file-icon" src="../images/word.png"/>
                    <div class="upload-status teacher">
                      <div class="attachment-name">{{ item.title }}</div>
                      <div class="progress" v-if="item.size">
                        <span>大小：{{item.size}}M</span>
                      </div>
                      <div class="progress" v-else-if="item.progress">
                          <span>大小：{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
                      </div>
                    </div>
                  </div>
              </div>
              <div class="image-mask" v-else-if="curQuestionData.file&&curQuestionData.type!=4" @mouseover="mouseoverImg" @mouseleave="mouseleaveImg">
                 <el-image style="width:180px;height:100px" v-for="item in curQuestionData.file" :key="item.url" :src="item.url" :preview-src-list="[item.url]"></el-image>
                 <img v-if="isShowImg" class="imgSty" src="../images/magnify.png" alt="">
                </div>
              <!-- 判断题 -->
              <div class="TF-selection" v-if="questionType === 'TF'">
                <el-radio style="margin-bottom:20px" v-model="radio" :label="item.key" v-for="(item,index) of TFOption" :key="index"
                :class="formatOptionStyle(item.key)"
                :disabled="Boolean(curQuestionData.answer && query.type == 'check')">
                  <template>
                    <span class="selection-content" style="transform:translateY(-5px)">{{item.value}}</span>
                  </template>
                </el-radio>
              </div>
              <!-- 单选题 -->
              <div class="TF-selection" v-else-if="questionType === 'single'">
                <el-radio-group
                v-model="singleSelectRadio" :disabled="Boolean(curQuestionData.answer && query.type == 'check')">
                <div class="signal-choose" v-for="item of curQuestionData.option" :key="item.key">
                  <el-radio
                  :label="item.key"
                  :class="formatOptionStyle(item.key)"
                  >
                    <template>
                      <span class="selection-item">{{item.key}}</span>
                      <span class="selection-content">{{item.value}}</span>
                      <!-- <img :src="item.img" alt="" v-else-if="item.type === 1"
                        style="width: 200px; height: 200px; vertical-align: top; transform: translateY(10px)" />
                      <div v-else-if="item.type === 2" style="display: inline-block; transform: translateY(20px);">
                        <span class="selection-content">{{item.content}}</span>
                        <img :src="item.img" alt="" style="width: 200px; height: 200px; vertical-align: top" />
                      </div> -->
                    </template>
                  </el-radio>
                   <div class="image-mask" v-if="item.file && item.file.length">
                       <el-image style="width:180px;height:100px" v-for="(items,index) in item.file" :key="index" :src="items.url"  :preview-src-list="[items.url]" @mouseover="mouseoverImgs(item)" @mouseleave="mouseleaveImgs()"></el-image>
                       <img v-show="showOptionId==item.key"  class="imgSty" src="../images/magnify.png" alt="">
                    </div>
                </div>
                </el-radio-group>
              </div>
              <!-- 多选题 -->
              <div class="TF-selection" v-else-if="questionType === 'multiple'">
                <el-checkbox-group v-model="multipleList" :disabled="Boolean(curQuestionData.answer && query.type == 'check')">
                  <div class="signal-choose" v-for="item of curQuestionData.option" :key="item.key">
                  <el-checkbox
                  :label="item.key"
                  :class="formatOptionStyle(item.key)"
                  >
                    <template>
                      <span class="selection-item">{{item.key}}</span>
                      <span class="selection-content">{{item.value}}</span>
                      <!-- <img  alt="" :src="item.img"  v-else-if="item.type === 1"
                        style="width: 200px; height: 200px; vertical-align: top; transform: translateY(10px);" />
                      <div v-else-if="item.type === 2" style="display: inline-block; transform: translateY(20px);">
                        <div class="selection-content">{{item.content}}</div>
                        <img :src="item.img" alt="" style="width: 200px; height: 200px; vertical-align: top" />
                      </div> -->
                    </template>
                  </el-checkbox>
                    <div class="image-mask" v-if="item.file && item.file.length">
                       <el-image style="width:180px;height:100px" v-for="(items,index) in item.file" :key="index" :src="items.url"  :preview-src-list="[items.url]" @mouseover="mouseoverImgs(item)" @mouseleave="mouseleaveImgs()"></el-image>
                       <img v-show="showOptionId==item.key"  class="imgSty" src="../images/magnify.png" alt="">
                    </div>
                  </div>
                  
                </el-checkbox-group>
              </div>
              <!-- 简答题 -->
              <div class="TF-selection" v-else-if="questionType === 'brief'">
                <div class="brief-input-box">
                  <el-input   maxlength="1000"  type="textarea" placeholder="请输入内容" v-model="briefAnswer" :disabled="Boolean(query.type == 'check')"></el-input>
                  <!-- <span class="answer-text">回答</span> -->
                </div>
                <div class="attachment-list">
                  <div class="attachment-item" v-for="(item,index) of attachmentList" :key="index">
                    <img v-if="item.title.endsWith('.pdf')" class="file-icon" src="../images/pdf.png"/>
                    <img v-else-if="item.title.endsWith('.zip')||item.title.endsWith('.rar')||item.title.endsWith('.7z')" class="file-icon" src="../images/yasuo.png"/>
                    <img v-else-if="item.title.endsWith('.jpg')||item.title.endsWith('.png')||item.title.endsWith('.jpeg')" class="file-icon" src="../images/picture.png"/>
                    <img v-else-if="item.title.endsWith('.mp4')" class="file-icon" src="../images/video.png"/>
                    <img v-else-if="item.title.endsWith('.xls')||item.title.endsWith('.xlsx')||item.title.endsWith('.xlsm')" class="file-icon" src="../images/excel.png"/>
                    <img v-else-if="item.title.endsWith('.ppt')" class="file-icon" src="../images/ppt.png"/>
                    <img v-else class="file-icon" src="../images/word.png"/>
                    <div class="upload-status">
                      <div class="attachment-name">{{ item.title }}</div>
                      <div class="progress" v-if="!item.done && !item.err && item.progress">
                        <span>{{(item.progress.loaded/(1024*1024)).toFixed(2)}}M/{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
                        <el-progress
                        :percentage="item.progress.percent*100"
                        :show-text="false"
                        define-back-color="rgb(255,255,255)"
                        color="#10A675"
                        style="width:155px; margin:0 6px"></el-progress>
                        <span>{{(item.progress.speed/(1024*1024)).toFixed(2)}}m/s</span>
                      </div>
                      <div class="progress" v-else-if="item.done && !item.err && item.progress">
                        <span>大小：{{(item.progress.total/(1024*1024)).toFixed(2)}}M</span>
                      </div>
                      <div class="progress" v-else-if="item.size">
                        <span>大小：{{item.size}}M</span>
                      </div>
                      <div class="progress" v-else-if="item.err">
                        <span style="color:#F56C6C">上传失败，请删除重新上传</span>
                      </div>
                    </div>
                    <img class="close-icon" src="../images/ico_guanbi@2x.png" v-if="!Boolean(query.type == 'check')" @click="deleteAttachment(index)" />
                  </div>
                </div>
                <div class="add-attachment" @click="chooseFile" v-if="query.type == 'do' || query.type == 'edit'">
                  <img src="../images/ico_add@2x.png" />
                  <span>添加附件</span>
                  <input
                  type="file"
                  style="display: none"
                  ref="updateFile"
                  @change="afterRead($event)" />
                </div>
                <p v-if="curQuestionData.type == 4 && this.query.status == 2" style="font-weight: 600;font-size: 18px;color: #1872ed;">本题得分:{{curQuestionData.user_score}}分</p>
              </div>
            </div>
            <div class="exercises-answer" v-if="query.type == 'check' &&(curQuestionData.answer || curQuestionData.analysis) ">
              <p class="exercises-answer-result">
                <template v-if="curQuestionData.type !== 4">
                  <span class="wrong" v-if="!correct">回答错误</span>
                  <span class="correct" v-else>回答正确</span>
                  <span v-if="curQuestionData.type == 3">正确答案：{{curQuestionData.answer == 1?'正确':'错误'}}</span>
                  <span v-else>正确答案：{{curQuestionData.answer.split('').sort().join('')}}</span>
              </template>
              </p>
              <!-- <div v-if="this.query.status == 2">
                <p v-if="curQuestionData.type == 2" style="font-weight: 600;font-size: 17px;">多选题打分:{{curQuestionData.user_score}}分</p>
                <p v-if="curQuestionData.type == 1" style="font-weight: 600;font-size: 17px;">单选题打分:{{curQuestionData.user_score}}分</p>
                <p v-if="curQuestionData.type == 3" style="font-weight: 600;font-size: 17px;">判断题打分:{{curQuestionData.user_score}}分</p>
              </div> -->
              <div class="exercises-answer-analysis">
                <p>
                  <i></i>
                  <span>题目解析</span>
                </p>
                <div>
                  {{curQuestionData.analysis?curQuestionData.analysis:'暂无解析'}}
                </div>
                <!-- <p>
                  参考链接：
                  <span style="cursor: pointer;" @click="handleToReferPage(curQuestionData.link)">{{curQuestionData.link}}</span>
                </p> -->
              </div>
            </div>
          </div>
          <!-- <div class="exercises-right">
            <h4>答题卡</h4>
            <ul class="exercises-card">
              <li class="exercises-card-item" v-for=" (item,index) of questionCard" :key="item.number"
                :class="item.un==0?'has-done':''" :style="{border:(curQuestionNum==index?'1px solid #0BB65D':'')}"
                @click="changeQuestionOnCard(item.number,index)">{{index+1}}</li>
            </ul>
            <button class="submit-btn" @click="handleSumitPaper">提交试卷</button>
          </div> -->
          <div class="submit-layout" v-if="showSubmitPaper">
            <img src="@/views/images/ico_wancheng@2x.png" />
            <div class="title">恭喜您完成本次作业</div>
            <div class="sub-title">本次部分得分</div>
            <div class="score">
              {{ getScore }}<span>分</span>
            </div>
            <div class="tips">简答题分数待老师批阅后可查看</div>
            <div class="feedback-btn">
              <button @click="comfirmBack">返回主页</button>
            </div>
            <!-- <img class="feedback-close" @click="handleCloseSubmitPaper" src="../img/ico_guanbi2@2x.png" /> -->
          </div>
          <div class="mask" v-if="showSubmitPaper" ></div>
        </div>
      </div>
      <div class="switch-question">
              <div class="switch-prev-question" @click="toPrevQuestion" v-if="!isFirst">
                <!-- <img src="../img/ico_gengduo@2x (3).png" alt="" /> -->
                <span>上一题</span>
              </div>
              <!-- <div class="submit-question">
                <div style="background: none;">
                  <span>{{curQuestionNum + 1}}</span>
                  <span style="color: #202020;">/{{curQuestionData.all_num}}</span>
                </div>
              </div> -->
              <div class="switch-prev-questionyi" @click="toPrevQuestionbc" v-if="query.flag == 1"> 
                <!-- <img src="../img/ico_gengduo@2x (3).png" alt="" /> -->
                <span>保存草稿</span>
              </div>
              <div class="switch-prev-questionyi" @click="toPrevQuestionbc" v-if="query.flag == 2"> 
                <!-- <img src="../img/ico_gengduo@2x (3).png" alt="" /> -->
                <span>保存草稿</span>
              </div>
              <div class="switch-next-question" @click="toNextQuestion" v-if="!(isEnd && query.type == 'check')">
                <span>{{ isEnd?'提交':'下一题' }}</span>
                <!-- <img src="../img/ico_gengduo@2x (1).png" alt="" /> -->
              </div>
      </div>
  </div>

</template>

<script>
// import COS from 'cos-js-sdk-v5'
// import { getOnlineApi } from '@/utils/useProxyApi'
import { FileUploadType } from '@/utils/constant'
import { cosUpload } from '@/utils/cosUpload'

export default {
  data () {
      return {
        skeletonLoading: false,
        radio: '',
        singleSelectRadio: '',
        questionType: 'TF',
        multipleList: [],
        briefAnswer: '',
        showAnswer: false,
        collected: true,
        feedbackContent: '',
        feedbackLink: '',
        showFeedback: false,
        showDialogue: false,
        isWrongQuestion: false,
        isLogin: false,
        showSubmitPaper: false,
        circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        menuList: [{ id: 1, name: '学习中心' }, { id: 2, name: '分销赚钱' }, { id: 3, name: '我的订单' }, { id: 4, name: '账户中心' }, { id: 5, name: '退出登陆' }],
        userInfo: {},
        navLinkList: [],
        searchKey: '',
        partFiveData: {},
        webContactList: [],
        feedbackList: [{ id: 1, name: '题目错误' }, { id: 2, name: '答案错误' }, { id: 3, name: '解析错误' }, { id: 4, name: '其他' }],
        option: {
          num: '',
          ueid: '',
          cid: ''
        },
        TFOption:[{key:'1',value:'正确'},{key:'2',value:'错误'}],
        questionCard: [],
        questionList:[],
        curQuestionData:{},
        curQuestionNum: 0,
        curQuestionShowNum: 1,
        questionDetail: {},
        hasDone: false,
        userAnswer: [],
        recordTimer: null,
        curFeedbackType: [],
        testTime: '',
        testTimer: null,
        hasFinished: false,
        testScore: 0,
        attachmentList:[],
        commentFile:[],
        questionComment:'',
        uploading:false,
        getScore:0,
        showScore:0,
        totalScore:'',
        isShowImg:false,
        showOptionId:''
      }
    },
    props:{
      query:{
      type:Object,
      default(){
        return{}
      }
    }
    },
    created () {
    if(this.query.type == 'do'){
      this.getQuestionContent()
    }
    if(this.query.type == 'check' || this.query.type == 'edit'){
      this.getDoneQuestionContent()
    }
    
          // 初始化实例
    console.log('query',this.query)
    // this.cos = new COS({
    //   // getAuthorization 必选参数
    //   getAuthorization: function (options, callback) {
    //     // 异步获取临时密钥
    //     // 服务端 JS 和 PHP 例子：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
    //     // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
    //     // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
    //     // const baseUrl = process.env.VUE_APP_API_ONLINE_SCHOOL
    //     const baseUrl = getOnlineApi()
    //     var url = `${baseUrl}/common/index/getCosSign` // url替换成您自己的后端服务
    //     var xhr = new XMLHttpRequest()
    //     xhr.open('GET', url, true)
    //     xhr.onload = function (e) {
    //       try {
    //         var data = JSON.parse(e.target.responseText)
    //         var credentials = data.data.credentials
    //       } catch (e) {
    //         console.log(e);
    //       }
    //       if (!data || !credentials) {
    //         return console.error(
    //           'credentials invalid:\n' + JSON.stringify(data, null, 2)
    //         )
    //       }
    //       callback({
    //         TmpSecretId: credentials.tmpSecretId,
    //         TmpSecretKey: credentials.tmpSecretKey,
    //         SecurityToken: credentials.sessionToken,
    //         // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
    //         StartTime: data.data.startTime, // 时间戳，单位秒，如：1580000000
    //         ExpiredTime: data.data.expiredTime, // 时间戳，单位秒，如：1580000000
    //       })
    //     }
    //     xhr.send()
    //   },
    // })
    },
    computed: {
      isEnd () {
        return this.curQuestionNum+1 >= this.questionList.length
      },
      isFirst () {
        return this.curQuestionNum <= 0
      },
      correct(){
        if(this.curQuestionData.type && this.curQuestionData.type !== 4 && this.curQuestionData.user_answer && (this.curQuestionData.answer)){
          return [...this.curQuestionData.user_answer].sort().join('') == [...this.curQuestionData.answer].sort().join('')
        }
        return false
      },
      formatOptionStyle(){
        return function(key){
          if(this.questionType == 'multiple' && this.query.type == 'check' && this.curQuestionData.user_answer.includes(key) &&
            this.curQuestionData.answer.includes(key)
          ){
            return 'correct-option'
          }
          if(this.questionType == 'multiple' && this.query.type == 'check' && this.curQuestionData.user_answer.includes(key) &&
            !this.curQuestionData.answer.includes(key)
          ){
            return 'wrong-option'
          }
          if(this.curQuestionData.user_answer == key && this.query.type == 'check' && this.curQuestionData.answer == key){
            return 'correct-option'
          }
          
          if(this.curQuestionData.user_answer == key && this.query.type == 'check' && this.curQuestionData.answer != key){
            return 'wrong-option'
          }
          return ''
        }
      }
    },
   watch:{
    curQuestionNum(val){
      this.radio = ''
      this.singleSelectRadio = ''
      this.multipleList = []
      this.briefAnswer = ''
      this.attachmentList=[]
      this.curQuestionData = this.questionList[val]
      console.log(this.questionList)
      switch (this.curQuestionData.type) {
            case 3:
              this.questionType = 'TF'
              if (this.curQuestionData.user_answer) {
                this.radio = this.curQuestionData.user_answer
              }
              break
            case 1:
              this.questionType = 'single'
              if (this.curQuestionData.user_answer) {
                this.singleSelectRadio = this.curQuestionData.user_answer
                console.log(this.singleSelectRadio)
              }
              break
            case 2:
              this.questionType = 'multiple'
              if (this.curQuestionData.user_answer) {
                this.multipleList = this.curQuestionData.user_answer.split('')
                console.log(this.multipleList)
              }
              break
            case 4:
              this.questionType = 'brief'
              if (this.curQuestionData.user_answer || (this.curQuestionData.answer_file && this.curQuestionData.answer_file.length)) {
                this.briefAnswer = this.curQuestionData.user_answer
                this.attachmentList = this.curQuestionData.answer_file || []
              }
              break
      }
    }
   },
   methods: {
    mouseoverImgs(item){
      this.showOptionId=item.key
    },
    mouseleaveImgs(){
      this.showOptionId=''
    },
    mouseoverImg(){
      this.isShowImg=true
    },
    mouseleaveImg(){
      this.isShowImg=false
    },
      // 获取当前题目内容请求
      async getQuestionContent () {
        const data = { qt_id: this.query.qt_id }
        const res = await this.$axios.post('/user/index/dotask', data)
        if (res.data.code === 200) {
          this.questionList = res.data.data
          console.log(this.questionList)
          this.skeletonLoading = false
          if(this.questionList.length){
            this.curQuestionData = this.questionList[0]
          }
          console.log(this.curQuestionData)
          switch (this.curQuestionData.type) {
            case 3:
              this.questionType = 'TF'
              if (this.curQuestionData.user_answer) {
                this.radio = this.curQuestionData.user_answer
              }
              break
            case 1:
              this.questionType = 'single'
              if (this.curQuestionData.user_answer) {
                this.singleSelectRadio = this.curQuestionData.user_answer
              }
              break
            case 2:
              this.questionType = 'multiple'
              if (this.curQuestionData.user_answer) {
                this.multipleList = this.curQuestionData.user_answer.split('')
              }
              break
            case 4:
              this.questionType = 'brief'
              if (this.curQuestionData.user_answer) {
                this.briefAnswer = this.curQuestionData.user_answer
                this.attachmentList = this.curQuestionData.answer_file || []
              }
              break
      }
        }
      },
            // 获取已做题目内容请求
      async getDoneQuestionContent () {
        const data = { qt_id: this.query.qt_id, section_id:this.query.section_id, chapter_id:this.query.chapter_id, ucqid:this.query.ucqid}
        const res = await this.$axios.post('/user/index/see', data)
        if (res.data.code === 200) {
          this.questionList = res.data.data.answer_list.map(item=>{
              item.id = item.qid
              delete item.qid
              return item
          })
          this.showScore = res.data.data.comment.user_score
          this.totalScore = res.data.data.comment.total
          if(this.questionList.length){
            if(this.query.type == 'check' && this.query.status == 2){
              this.curQuestionNum = this.questionList.length-1
              this.curQuestionData = this.questionList[this.curQuestionNum]
              console.log('[<-- this.curQuestionData -->]',this.curQuestionData);            
              this.questionComment = res.data.data.comment.comment
              this.commentFile = res.data.data.comment.files
            }
            this.curQuestionData = this.questionList[0]
          }
          switch (this.curQuestionData.type) {
            case 3:
              this.questionType = 'TF'
              if (this.curQuestionData.user_answer) {
                this.radio = this.curQuestionData.user_answer
              }
              break
            case 1:
              this.questionType = 'single'
              if (this.curQuestionData.user_answer) {
                this.singleSelectRadio = this.curQuestionData.user_answer
              }
              break
            case 2:
              this.questionType = 'multiple'
              if (this.curQuestionData.user_answer) {
                this.multipleList = this.curQuestionData.user_answer.split('')
              }
              break
            case 4:
              this.questionType = 'brief'
              if (this.curQuestionData.user_answer) {
                this.briefAnswer = this.curQuestionData.user_answer
                this.attachmentList = this.curQuestionData.answer_file || []
              }
              break
      }
          switch (this.curQuestionData.iscoll) {
            case 0:
              this.collected = false
              break
            case 1:
              this.collected = true
          }
          console.log(this.questionList)
        }
      },
      // 在答题卡上切换题目
      async changeQuestionOnCard (num) {
        this.curQuestionNum = num
        this.radio = ''
        this.briefAnswer = ''
        this.singleSelectRadio = ''
        this.multipleList = []
        await this.getQuestionContent(this.curQuestionNum, this.option.uqid)
        this.changeURLParam('num', this.curQuestionNum)
      },
      // 保存草稿
      async toPrevQuestionbc () {
        console.log('rrrrrr-----123', this.questionList)
        const content = this.questionList.map(item=>{
          console.log('rrrrrr-----', this.briefAnswer)
          console.log(item)
          
          if(item.type == 4){
            if(this.briefAnswer){
                if(item.id == this.curQuestionData.id){
                  item.user_answer = this.briefAnswer
                }
            } 
            // else {
            //   if(item.id == this.curQuestionData.id){
            //       item.user_answer = this.briefAnswer
            //     }
            // }
            if(item.user_answer == null) {
              item.user_answer = ''
            }
            return{
              file:item.answer_file?JSON.stringify(item.answer_file) || "" : '',
              qid:item.id,
              title:item.title,
              type:item.type,
              answer:item.user_answer,
              score:0
            }
          }else{
            if(this.radio){
                if(item.id == this.curQuestionData.id){
                  item.user_answer = this.radio
                }
            }
            if(this.singleSelectRadio){
                if(item.id == this.curQuestionData.id){
                  item.user_answer = this.singleSelectRadio
                }
            }
            if(this.multipleList.length){
                if(item.id == this.curQuestionData.id){
                  item.user_answer = this.multipleList.join('')
                }
            }
            if(item.user_answer == null) {
              item.user_answer = ''
            }
            return{
              qid:item.id,
              title:item.title,
              answer:item.user_answer,
              type:item.type,
              file:item.answer_file?JSON.stringify(item.answer_file) || "" : '',
              score:  [...item.user_answer].sort().toString() == [...item.answer].sort().toString()?item.score:0
            }
          }
        })
        this.getScore = content.reduce((total,item)=>{return total+item.score},0)
        const data = {
          cq_id: this.query.cq_id,
          content:JSON.stringify(content)
        }
        const res = await this.$axios.post('/user/index/save', data)
        if (res.data.code === 200) {
          // this.showSubmitPaper = true
          this.$message({
              type: 'success',
              message: '保存草稿成功'
          })
          // eslint-disable-next-line vue/no-mutating-props
          this.query.flag = 1
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
      },
      // 提交答案请求
      async sumbitAnswerRequest () {
        const content = this.questionList.map(item=>{
          console.log(item)
          if(item.type == 4){
            return{
              file:item.answer_file?JSON.stringify(item.answer_file) || "" : '',
              qid:item.id,
              title:item.title,
              type:item.type,
              answer:item.user_answer,
              score:0
            }
          }else{
            return{
              qid:item.id,
              title:item.title,
              answer:item.user_answer,
              type:item.type,
              file:item.answer_file?JSON.stringify(item.answer_file) || "" : '',
              score:[...item.user_answer].sort().toString() == [...item.answer].sort().toString()?item.score:0
            }
          }
        })
        this.getScore = content.reduce((total,item)=>{return total+item.score},0)
        const data = {
          cq_id: this.query.cq_id,
          content:JSON.stringify(content)
        }
        const res = await this.$axios.post('/user/index/submit', data)
        if (res.data.code === 200) {
          this.showSubmitPaper = true
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
      },
      // 下一题
      async toNextQuestion () {
        console.log(this.curQuestionData.id)
        if(this.query.type == 'check'){
          this.curQuestionNum++
          return
        }
        // if(this.uploading){
        //     this.$message.error('请等待文件上传完成再操作')
        //   return
        // }
        if(this.radio){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.radio
            }
          })
        }
        if(this.singleSelectRadio){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.singleSelectRadio
            }
          })
        }
        if(this.multipleList.length){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.multipleList.join('')
            }
          })
        }
        if(this.briefAnswer){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.briefAnswer
            }
          })
        }
        if(this.attachmentList instanceof Array && (this.attachmentList.length || this.attachmentList.length === 0)){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.answer_file= this.attachmentList.map(item=>{
                if(item.size){
                  return {
                  title:item.title,
                  url:item.url,
                  size:item.size
                }
                }
                return {
                  title:item.title,
                  url:item.url,
                  size:(item.progress.total/(1024*1024)).toFixed(2)
                }
              })
            }
          })
        }
        if(this.isEnd){
          const endTime = new Date(this.query.end_time).getTime()
          const nowTime = new Date().getTime()
          const result = this.questionList.some(item=> !item.user_answer)
          let tips = ''
          if(result){
            tips = '当前有作业未填写，请填写后提交'
          }else{
            if(nowTime>endTime){
              tips="当前已过截止时间，提交后为迟交状态，确定还要提交吗？"
            }else{
              tips="请仔细检查作业，是否确认提交"
            }
          }
          this.$confirm(tips, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showCancelButton:!result,
          center:true,
          type: 'warning'
        }).then(() => {
          if(result)return
          this.sumbitAnswerRequest()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
          return
        }
        this.curQuestionNum++
        
        // this.briefAnswer = ''
        // this.singleSelectRadio = ''
        // this.multipleList = []
      },
      // 上一题
      async toPrevQuestion () {
        if(this.query.type == 'check'){
          this.curQuestionNum--
          return
        }
        // if(this.uploading){
        //     this.$message.error('请等待文件上传完成再操作')
        //   return
        // }
        if(this.radio){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.radio
            }
          })
        }
        if(this.singleSelectRadio){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.singleSelectRadio
            }
          })
        }
        if(this.multipleList.length){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.multipleList.join('')
            }
          })
        }
        if(this.briefAnswer){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.user_answer = this.briefAnswer
            }
          })
        }
        if(this.attachmentList.length){
          this.questionList.forEach(item=>{
            if(item.id == this.curQuestionData.id){
              item.answer_file= this.attachmentList.map(item=>{
                if(item.size){
                  return {
                  title:item.title,
                  url:item.url,
                  size:item.size
                }
                }
                return {
                  title:item.title,
                  url:item.url,
                  size:(item.progress.total/(1024*1024)).toFixed(2)
                }
              })
            }
          })
        }
        this.curQuestionNum--
      },
      // 每分钟调用答题时间接口
      recordTimeMin () {
        this.recordTimer = setInterval(() => {
          this.recordTimeRequest()
        }, 60000)
      },
      // 选择反馈类型
      changeFeedbackType (id, name) {
        if (this.curFeedbackType.indexOf(name) !== -1) {
          this.curFeedbackType.splice(this.curFeedbackType.indexOf(name), 1)
        } else {
          this.curFeedbackType = [...this.curFeedbackType, name]
        }
        console.log(this.curFeedbackType)

      },
 

      handleOpenFeedback () {
        this.showFeedback = true
        this.showDialogue = true
        this.handleCloseLogin()
        const body = document.querySelector('body')
        if (this.showFeedback) {
          body.setAttribute('style', 'position:fixed;left: 0px;right: 0px;overflow: hidden;')
        }
      },
      handlePreventScroll () {
        const body = document.querySelector('body')
        if (this.showFeedback || this.showSubmitPaper) {
          body.setAttribute('style', 'position:fixed;left: 0px;right: 0px;overflow: hidden;')
        }
      },
      handleCloseFeedback () {
        this.showFeedback = false
        this.showDialogue = false
        const body = document.querySelector('body')
        body.removeAttribute('style')
      },
      handleSumitPaper () {
        this.showDialogue = true
        this.showSubmitPaper = true
        this.handlePreventScroll()
      },
      handleCloseSubmitPaper () {
        this.showDialogue = false
        this.showSubmitPaper = false
        const body = document.querySelector('body')
        body.removeAttribute('style')
      },
      // 跳转参考链接
      handleToReferPage(link){
        window.open(link,'_blank')
      },
      chooseFile() {
      this.$refs.updateFile.click()
      },
          // 上传头像
    async afterRead(e) {
      // 此时可以自行将文件上传至服务器
      let file = e.target.files[0]
      this.attachmentList.push({title:file.name, done:false, err:false})
      this.uploading = true
      // this.cos.putObject(
      //   {
      //     Bucket: 'tengface-live-user-1308721187',
      //     /* 填入您自己的存储桶，必须字段 */
      //     Region: 'ap-guangzhou',
      //     /* 存储桶所在地域，例如ap-beijing，必须字段 */
      //     Key: new Date().getTime() + file.name,
      //     /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
      //     StorageClass: 'STANDARD',
      //     Body: file, // 上传文件对象
      //     onProgress: progressData=> {
      //       this.attachmentList.forEach((item,i)=>{
      //         if(item.title === file.name){
      //           this.$set(this.attachmentList[i], 'progress', progressData)
      //         }
      //       })
      //     },
      //   },
      //   (err, data) => {
      //     this.uploading = false
      //     if (data.statusCode === 200) {
      //       this.attachmentList.forEach((item,i)=>{
      //         if(item.title === file.name){
      //           this.$set(this.attachmentList[i], 'done', true)
      //           this.$set(this.attachmentList[i], 'url', `http://${data.Location}`)
      //         }
      //       })
      //     }
      //     if(err){
      //       this.attachmentList.forEach((item,i)=>{
      //         if(item.title === file.name){
      //           this.$set(this.attachmentList[i], 'err', true)
      //         }
      //       })
      //     }
      //   }
      // )
      try {
        const { url } = await cosUpload(file, false, FileUploadType.HOMEWORK, (process) => {
          this.attachmentList.forEach((item,i)=>{
            if(item.title === file.name){
              this.$set(this.attachmentList[i], 'progress', process)
            }
          })
        })
        this.attachmentList.forEach((item,i)=>{
          if(item.title === file.name){
            this.$set(this.attachmentList[i], 'done', true)
            this.$set(this.attachmentList[i], 'url', url)
          }
        })
      } catch(error) {
        console.log(error)
      } finally {
        this.uploading = false
      }
    },
    backLastPage(){
      console.log(this.query)
      if (this.query.flag == 1) {
        this.comfirmBack()
      } else {
        const tips = '返回将不会保存填写的内容，确定返回吗?'
        if(this.query.type == 'check'){
          this.comfirmBack()
          return
        }
        this.$confirm(tips, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center:true,
            type: 'warning'
          }).then(() => {
            this.comfirmBack()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });          
          });
      }
    },
    comfirmBack(){
      delete this.query.cq_id
      this.$emit('changePage',{page:'HomeworkDetail',query:this.query})
    },
    deleteAttachment(index){
      this.uploading =  false
      this.attachmentList.splice(index,1)
    },
    handleDownloadFile(url){
      window.open(url,'_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  float: left;
  padding: 20px 30px;
  min-height: 880px;
  .header{
    padding-bottom: 17px;
    border-bottom: 1px solid #e8eaec;
    .header-top{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      img{
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .header-bottom{
      display: flex;
      font-size: 14px;
      color: #808695;
      margin-left: 30px;
      div{
        margin-right: 30px;
      }
    }
  }
}
.settle-body{
  width: 100%;
  background: #F7F7F7;
  font-size: 14px;
  line-height: 22px;
  color: #202020;
}
.exercises-index-header{
  display: flex;
  align-items: center;
  // justify-content: center;
  img{
    width: 20px;
    height: 20px;
    margin-right: auto;
   
  }
  .get-score{
    align-self: start;
    color: #808695;
    font-size: 14px;
    .num{
      color: #F34718;
      font-size: 26px;
      margin-left: 4px;
      font-weight: 600;
    }
  }
  .exercises-info{
    margin:0 auto;
    width: 600px;
    padding-top: 10px;
    .exercises-title{
      font-size: 24px;
      font-weight: 500;
      text-align: left;
      color: #202020;
      line-height: 22px;
      margin-bottom: 20px;
      text-align: center;
    }
    .exercises-time{
      display: flex;
      font-size: 14px;
      font-weight: 400;
      color: #808695;
      justify-content: space-between;
      margin-bottom:20px;
    }
  }
}
.comment{
  width: 880px;
  background: #eff2f5;
  font-size: 16px;
  color: #1872ed;
  box-sizing: border-box;
  padding: 11px 16px;
  margin-top: 10px;
  .attachment-list{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin: 10px 0;
    gap: 10px;
    .attachment-item{
      width: 276px;
      color: #202020;
      background: #ffffff;
      margin-bottom: 0;
      .upload-status{
        display: flex;
        align-items: center;
        .attachment-name{
          max-width: 177px;
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap
        }
      }

    }
   
  }
}
 .image-mask{
      width: 180px;
      height: 100px;
      position: relative;
      margin: 10px 0px;
    }
    .image-mask:hover{
      opacity: 0.3;
      background: rgba(0,0,0,0);
      // width: 180px;
      // height: 100px;
      border-radius: 4px; 
    }
    .imgSty{
      position: absolute;
      right: 6px;
      bottom: 6px;
    }
.exercises-body{
  position: relative;
}
.exercises-left{
  background-color: #ffffff;
  width: 100%;
  box-sizing: border-box;
  // margin-right: 20px;
  overflow-y: auto;
  overflow-x: hidden;
}
/* 答题卡 */
.exercises-right{
  width: 252px;
  height: 382px;
  background: #ffffff;
  position: absolute;
  right: -260px;
  top: 0;
  box-sizing: border-box;
  padding: 24px 22px 30px 26px;
}
.exercises-right h4{
  font-size: 18px;
  line-height: 24px;
  color: #202020;
  font-weight: bolder;
  text-align: center;
  margin-bottom: 20px;
}
.exercises-right .exercises-card{
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  max-height: 230px;
}
.exercises-right .exercises-card-item{
  width: 30px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid #DDDDDD;
  color: #979CA1;
  background: #FEFFFE;
  line-height: 30px;
  text-align: center;
  margin-right: 8px;
  margin-bottom: 10px;
  cursor: pointer;
}
.exercises-right .exercises-card-item:nth-child(5n){
  margin-right: 0;
}
.exercises-right .exercises-card .active-true{
  background: #D1F1E6;
  color: #0BB65D;
  border: none;
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.exercises-right .exercises-card .active-false{
  background: #FDDAD1;
  color: #F34718;
  border: none;
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.exercises-right .exercises-card .active-cur{
  color: #26BE6F;
  border: 1px solid #0BB65D;
}
.exercises-right button{
  width: 92px;
  height: 34px;
  color: #FFFFFF;
  text-align: center;
  line-height: 34px;
  background: linear-gradient(315deg, #ED3F10, #FB724D);
  border-radius: 17px;
  cursor: pointer;
  border: none;
  margin: 0 auto;
  display: block;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}
/* 滚动条样式 */
.exercises-card::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.exercises-card::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
.exercises-card::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.exercise-body-top{
  display: flex;
  padding-bottom: 9px;
  border-bottom: 1px solid #EFEFEF;
}
.exercise-body-top .mode{
  margin-right: 30px;
  color: #202020;
  line-height: 20px;
}
.exercise-body-top .mode:first-child{
  font-weight: 700;
  font-size: 16px;
  position: relative;
}
.exercise-body-top .mode:last-child{
  font-size: 14px;
}
.exercise-body-top .mode i{
  position: absolute;
  bottom: -8px;
  width: 64px;
  height: 4px;
  border-radius: 2px;
  background: linear-gradient(315deg,#ED3F10,#FB724D);
}
.exercise-body-top .feedback{
  margin-left: auto;
}
.exercise-body-top  img{
  width: 20px;
  height: 20px;
  vertical-align: bottom;
}
.exercise-body-top .feedback{
  margin-right: 20px;
  cursor: pointer;

}
.exercise-body-top .collect{
  cursor: pointer;
}
.exercise-TF{
  width: 800px;
  padding-bottom: 30px;
}
.exercise-TF h3{
  font-size: 24px;
  line-height: 22px;
  color: #202020;
  font-weight: bolder;
  text-align: center;
  padding: 30px 0;
}
.exercise-TF p{
  font-size: 16px;
  font-weight: 400;
  color: #202020;
  line-height: 28px;
}
.exercise-TF p span{
  
}
::v-deep .el-radio__inner {
    border-radius: 50%;
    width: 18px;
    height: 18px;
  }

  ::v-deep .el-radio__input.is-checked .el-radio__inner::after {
    content: "";
    width: 10px;
    height: 5px;
    border: 1px solid white;
    border-top: transparent;
    border-right: transparent;
    text-align: center;
    display: block;
    position: absolute;
    top: 3px;
    left: 2px;
    vertical-align: middle;
    transform: rotate(-45deg);
    border-radius: 0px;
    background: none;
  }
  ::v-deep .el-radio__input.is-checked.is-disabled .el-radio__inner::after {
    content: "";
    width: 10px;
    height: 5px;
    border: 1px solid #888888;
    border-top: transparent;
    border-right: transparent;
    text-align: center;
    display: block;
    position: absolute;
    top: 3px;
    left: 2px;
    vertical-align: middle;
    transform: rotate(-45deg);
    border-radius: 0px;
    background: none;
  }
  ::v-deep .el-checkbox__inner{
    border-radius: 50%;
    width: 18px;
    height: 18px;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::after {
    content: "";
    width: 10px;
    height: 5px;
    border: 1px solid white;
    border-top: transparent;
    border-right: transparent;
    text-align: center;
    display: block;
    position: absolute;
    top: 3px;
    left: 2px;
    vertical-align: middle;
    transform: rotate(-45deg);
    border-radius: 0px;
    background: none;
  }
/* 判断题 */
.exercise-TF .TF-selection{
  display: flex;
  flex-direction: column;
}
.TF-selection{
  .correct-option{
    ::v-deep .el-radio__input.is-disabled.is-checked .el-radio__inner{
      border-color: #1872ed !important;
      background: #1872ed !important;
    }
    ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{
      border-color: #1872ed !important;
      background: #1872ed !important;
    }
    ::v-deep .el-radio__input.is-checked.is-disabled .el-radio__inner::after{
      content: "";
      width: 10px;
      height: 5px;
      border: 1px solid #ffffff;
      border-top: transparent;
      border-right: transparent;
      text-align: center;
      display: block;
      position: absolute;
      top: 3px;
      left: 2px;
      vertical-align: middle;
      transform: rotate(-45deg);
      border-radius: 0px;
      background: none;
    }
    ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
      border-color:#ffffff
    }
  }
  .wrong-option{
    ::v-deep .el-radio__input.is-disabled.is-checked .el-radio__inner{
      border-color: #f34718 !important;
      background: #f34718 !important;
    }
    ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{
      border-color: #f34718 !important;
      background: #f34718 !important;
    }
    ::v-deep .el-radio__input.is-checked.is-disabled .el-radio__inner::after{
      content: "";
      width: 13px;
      height: 5px;
      border: 1px solid #ffffff;
      border-top: transparent;
      border-right: transparent;
      border-left: transparent;
      text-align: center;
      display: block;
      position: absolute;
      top: 4px;
      left: -1px;
      vertical-align: middle;
      transform: rotate(-45deg);
      border-radius: 0px;
      background: none;
    }
    ::v-deep .el-radio__input.is-checked.is-disabled .el-radio__inner::before{
      content: "";
      width: 13px;
      height: 5px;
      border: 1px solid #ffffff;
      border-top: transparent;
      border-right: transparent;
      border-left: transparent;
      text-align: center;
      display: block;
      position: absolute;
      top: 8px;
      left: 0px;
      vertical-align: middle;
      transform: rotate(-138deg);
      border-radius: 0px;
      background: none;
    }
    // ::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
    //   border-color:#ffffff
    // }
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::after{
      content: "";
      width: 13px;
      height: 5px;
      border: 1px solid white;
      border-top: transparent;
      border-right: transparent;
      border-left: transparent;
      text-align: center;
      display: block;
      position: absolute;
      top: 4px;
      left: -1px;
      vertical-align: middle;
      transform: rotate(-45deg);
      border-radius: 0px;
      background: none;
    }
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::before{
      content: "";
      width: 13px;
      height: 5px;
      border: 1px solid #ffffff;
      border-top: transparent;
      border-right: transparent;
      border-left: transparent;
      text-align: center;
      display: block;
      position: absolute;
      top: 8px;
      left: 0px;
      vertical-align: middle;
      transform: rotate(-138deg);
      border-radius: 0px;
      background: none;
    }
  }

}
.exercise-TF .TF-selection .selection-item{
  font-size: 16px;
  color: #888888;
  line-height: 28px;
  margin-right: 12px;
}
.exercise-TF .TF-selection .selection-content{
  font-size: 16px;
  color: #202020;
  line-height: 28px;
  // display: inline-block;
  // width: 750px;
  white-space:pre-wrap;
  vertical-align: top
}
.exercise-TF .el-radio{
  align-items: center ;
}
.signal-choose{
    margin-bottom: 20px;
}
.exercise-TF .el-radio__inner{
  width: 18px;
  height: 18px;
}
/* 单选题 */
.TF-selection .el-radio-group{
  display: flex;
  flex-direction: column;
}
.TF-selection .el-radio__inner::after{
  box-sizing: content-box;
  content: "";
  border: 1px solid #ffffff;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 6px;
  position: absolute;
  top: 3px;
  width: 3px !important;
  border-radius: 0;
  background: transparent !important;
  transform: rotate(45deg) scaleY(1) !important;
  transform-origin:center !important;
}
/* 多选题 */
.TF-selection .el-checkbox-group{
  display: flex;
  flex-direction: column;
}
/* 多选题 */
// .TF-selection .el-checkbox-group .el-checkbox{
//   margin-bottom: 20px;
// }
.TF-selection .el-textarea__inner:focus{
  border-color: #FB724D;
}
/* 简答题 */
.TF-selection .el-textarea__inner{
  background: #F7F7F7;
  resize:none;
  height: 180px;
  padding-left: 50px;
}
.TF-selection .brief-input-box{
  position: relative;
  ::v-deep .el-textarea__inner{
    height: 180px;
    font-size: 16px;
  }
}
.attachment-list{
  margin-top: 10px;
  .attachment-item{
    width: 440px;
    // height: 64px;
    background: #EFF2F5;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 5px 16px 5px 6px;
    margin-bottom: 10px;
    border-radius: 4px;
    cursor: pointer;
    .attachment-name{
      max-width: 280px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap
    }
    .file-icon{
      width: 32px;
      height: 32px;
      margin-right: 10px;
    }
    .upload-status{
      .progress{
        display: flex;
        margin-top: 6px;
        align-items: center;
        ::v-deep .el-progress-bar__outer{
          background-color:#ffffff;
        }
        span{
          font-size: 12px;
          color: #888888;
        }
      }
    }
    .upload-status.teacher{
      display: flex;
      align-items: center;
      width: 100%;
      .progress{
        margin-top: 0;
       margin-left: auto;
      }
    }
    .close-icon{
      width: 16px;
      height: 16px;
      margin-left: auto;
      cursor: pointer;
    }
  }
}
.add-attachment{
  color: #1872ed;
  display: flex;
  align-items: center;
  // margin-top: 16px;
  font-size: 16px;
  cursor: pointer;
  img{
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
}
.TF-selection .brief-input-box .answer-text{
  position: absolute;
  top: 6px;
  left: 13px;
  color: #c0c4cc;
}
.switch-question{
  display: flex;
  font-size: 14px;
  line-height: 28px;
  color: #6B6B6B;
  align-items: center;
  margin-bottom: 30px;
  margin-top: 30px;
}
.switch-question img{
  width: 14px;
  height: 14px;
  vertical-align: middle;
  transform: translateY(-1px);
}
.switch-question .switch-prev-question img{
  margin-right: 8px;
}
.switch-question .switch-next-question img{
  margin-left: 8px;
}
.switch-question .switch-prev-question, .switch-question .switch-next-question{
  cursor: pointer;
}
.submit-question{
  display: flex;
  margin-left: auto;
  align-items: center;
}
.submit-question div{
  color: #202020;
  margin-right: 10px;
}
.submit-question div span:first-child{
  color: #F34718;
}
.switch-next-question{
  width: 92px;
  height: 34px;
  color: #FFFFFF;
  text-align: center;
  line-height: 34px;
  background: #1872ed;
  border-radius: 17px;
  cursor: pointer;
  margin-left: auto;
}
.switch-prev-questionyi{
  width: 92px;
  height: 34px;
  color: #202020;
  text-align: center;
  line-height: 34px;
  background: #EFF2F5;
  border-radius: 17px;
  cursor: pointer;
  margin-left: auto;
}
.switch-prev-question{
  width: 92px;
  height: 34px;
  color: #202020;
  text-align: center;
  line-height: 34px;
  background: #EFF2F5;
  border-radius: 17px;
  cursor: pointer;
}
.exercises-answer .exercises-answer-result{
  font-size: 16px;
  line-height: 28px;
  font-weight: bolder;
  margin-bottom: 14px;
}
.exercises-answer .exercises-answer-result .wrong{
  color: #F34718;
  margin-right: 20px;
}
.exercises-answer .exercises-answer-result .correct{
  color: #0BB65D;
  margin-right: 20px;
}
.exercises-answer .exercises-answer-result .unknow{
  color: #409EFF;
  margin-right: 20px;
}
.exercises-answer .exercises-answer-analysis{
  background: #F7F7F7;
  box-sizing: border-box;
  padding: 12px 16px 12px 16px;
}
.exercises-answer-analysis p:nth-child(1){
  font-size: 16px;
  line-height: 28px;
  color: #202020;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.exercises-answer-analysis p i{
  display: inline-block;
  width: 4px;
  height: 16px;
  border-radius: 2px;
  background: #1872ed;
  margin-right: 10px;
}
.exercises-answer-analysis div{
  font-size: 16px;
  line-height: 28px;
  color: #888888;
  margin-bottom: 10px;
  max-width: 800px;
}
.exercises-answer-analysis p:nth-child(3){
  font-size: 16px;
  line-height: 28px;
  color: #888888;
}
.exercises-answer-analysis p:nth-child(3) span{
  color: #3F8EF8;
}
.mask{
  position: fixed;
  left: 0;
  top:0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2001;
}
.submit-layout{
  width: 360px;
  height: 420px;
  background-color: #ffffff;
  border-radius: 16px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  z-index: 11;
  box-sizing: border-box;
  padding: 60px 0 50px 0;
  z-index: 2002;
  display: flex;
  flex-direction: column;
  align-items: center;
  img{
    width: 64px;
    height: 64px;
    margin-bottom: 29px;
  }
  .title{
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #000000;
  }
  .sub-title{
    font-size: 14px;
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 19px;
    color: #888888;
  }
  .score{
    font-size: 36px;
    font-weight: 600;
    color: #000000;
    span{
      font-size: 14px;
      font-weight: 400;
      font-size: 14px;
      color: #888888;
    }
  
  }
  .tips{
    color: #F34718;
    font-size: 14px;
    margin-bottom: 12px;
  }
  .feedback-btn{
    button{
      width: 210px;
      height: 40px;
      background: linear-gradient(131deg,#73aaff 3%, #0053ff 90%);
      border-radius: 22px;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
      line-height: 40px;
      border: none;
      outline: none;
      cursor: pointer;
    }
  }
}
.submit-layout .title{
  font-size: 18px;
  line-height: 26px;
  font-weight: bold;
  color: #101010;
}
.submit-layout .feedback-btn button{
  font-size: 14px;
}
</style>